import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionDietaryNeedPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionDietaryNeed.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionDietaryNeed.button1'),
          value: 'no_restrictions',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button2'),
          value: 'gluten_free',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button3'),
          value: 'dairy_free',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button4'),
          value: 'nut_allergy',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button5'),
          value: 'shellfish_allergy',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button6'),
          value: 'low_carb_keto',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button7'),
          value: 'low_sodium',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button8'),
          value: 'halal',
        },
        {
          text: t('pages.onboarding.questionDietaryNeed.button9'),
          value: 'kosher',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
